import React, { FC } from "react";
import { useMediaQuery, Theme, Box } from "@mui/material";
import { AnySchema } from "yup";
import { UseFormSetValue } from "react-hook-form";

import { StyledTopNavContainer } from "./TopNav.styled";
import NavigationControls from "./components/NavigationControls";
import AvatarGroupDisplay from "./components/AvatarGroupDisplay";
import ActionsDropdown from "./components/ActionsDropdown";
import SearchInput from "./components/SearchInput";
import PreviousSubmissionsSelect from "./components/PreviousSubmissionsSelect";

import { Card, Stack } from "@components/base";

interface TopNav {
  setValue: UseFormSetValue<{ [x: string]: AnySchema }>;
}

const TopNav: FC<TopNav> = ({ setValue }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  if (isMobile) return null;

  return (
    <StyledTopNavContainer>
      <Card>
        <Box p={3}>
          <Stack
            direction="row"
            justifyContent="space-between"
            width="100%"
            alignItems="center"
          >
            <Stack direction="row" flexGrow={1} spacing={2} alignItems="center">
              <NavigationControls />
            </Stack>
            <Stack
              direction="row"
              flexGrow={1}
              spacing={2}
              alignItems="center"
              justifyContent="flex-end"
            >
              <PreviousSubmissionsSelect />
              <SearchInput />
              <AvatarGroupDisplay setValue={setValue} />
              <ActionsDropdown />
            </Stack>
          </Stack>
        </Box>
      </Card>
    </StyledTopNavContainer>
  );
};

export default TopNav;
